/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { notification, Upload, Button, Modal, Icon } from 'antd';
import fetch from 'isomorphic-fetch';
import { baseUrl } from 'config/env.config';
import { MAX_UPLOAD_FILE_SIZE } from 'config/app.config';
import classNames from 'classnames/bind';
import { intlShape, injectIntl } from 'react-intl';
import { Panel } from 'components/ui/index';
import defaultAvatar from 'assets/images/img-default-avatar.png';
import { getAuthorization } from 'utils/common';
import styles from '../index.less';


const cx = classNames.bind(styles);
const maxSize = MAX_UPLOAD_FILE_SIZE.USER_LOGO;


class Avator extends React.Component {
  state = {
    visible: false,
    isMaxSizeError: false,
    fileList: [],
    disabled: false,
  }
  onAllDone(response, error) {
    if (_.isEmpty(error)) {
      const logo = response && response.logo;
      this.props.setUserAvator(logo);
    }
  }
  onError(errorType) {
    const { formatMessage } = this.props.intl;
    notification.error({
      message: errorType === 'type' ? formatMessage({ id: 'global.ui.upload.errorType' }, { type: 'image/png,image/jpeg' }) : formatMessage({ id: 'global.ui.upload.errorMax' }, { size: _.round(MAX_UPLOAD_FILE_SIZE.USER_LOGO / 1024 / 1024) }),
    });
  }
  onOk() {
    const { fileList } = this.state;
    const { settingPageloading } = this.props;
    const formData = new FormData();
    settingPageloading({ isShow: true });
    formData.append('document', fileList[0]);
    fetch(`${baseUrl}/admin/files/user_avatar`, {
      credentials: 'include',
      headers: {
        Authorization: getAuthorization(),
      },
      method: 'POST',
      body: formData,
    }).then((response) => {
      response.json().then((data) => {
        this.onResponse(data);
      });
    });
  }
  onResponse = (data) => {
    const { settingPageloading } = this.props;
    if (data.hasOwnProperty('logo')) {
      this.onAllDone(data);
      this.setState({
        visible: false,
      });
    }
    if (data.hasOwnProperty('error')) {
      this.onError(data.error);
    }
    settingPageloading({ isShow: false });
  }
  onCancel = () => {
    this.setState({
      visible: false,
    });
  }
  showUploadDialog = () => {
    this.setState({
      visible: true,
      isMaxSizeError: false,
      disabled: true,
      fileList: [],
    });
  }
  beforeUpload = (file, fileList) => {
    if (fileList[0] && fileList[0].size > maxSize) {
      this.setState({
        isMaxSizeError: true,
        fileList,
        disabled: true,
      });
      return false;
    }
    this.setState({
      disabled: false,
      fileList: fileList.slice(-1),
      isMaxSizeError: false,
    });
    return false;
  }
  onRemove = () => {
    this.setState({
      fileList: []
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { email, name, avatar } = this.props.userInfo;
    const size = _.round(maxSize / 1024 / 1024, 2);
    const uploadProps = {
      name: 'document',
      accept: 'image/png,image/jpeg',
      withCredentials: true,
      beforeUpload: this.beforeUpload,
      fileList: this.state.fileList,
      onRemove: this.onRemove
    };

    return (
      <Panel>
        <div className={classNames(cx('avatar-img-wrapper'), 'mt-lg', 'mb-lg')} onClick={this.showUploadDialog}>
          <img className={cx('avatar-img')} src={avatar || defaultAvatar} alt="" />
        </div>
        <h1 className="text-center"> { formatMessage({ id: 'page.mySetting.hello' }, { name })} </h1>
        <p className={classNames(cx('avatar-text-email'), 'text-center')}>{email}</p>
        <Modal
          title={formatMessage({ id: 'page.mySetting.uploadUserAvatar' })}
          visible={this.state.visible}
          onCancel={() => this.onCancel()}
          footer={[
            <Button key="cancel" onClick={() => this.onCancel()}>{formatMessage({ id: 'global.ui.button.cancel' })}</Button>,
            <Button key="ok" onClick={() => this.onOk()} disabled={this.state.disabled}>{formatMessage({ id: 'global.ui.button.ok' })}</Button>,
          ]}
        >
          <Upload {...uploadProps}>
            <Button>
              <Icon type="upload" /> {formatMessage({ id: 'page.comInfo.clickToUpload' })}
            </Button>
          </Upload>
          {
            this.state.isMaxSizeError ?
              <p className="error-msg"> {formatMessage({ id: 'global.ui.upload.errorMax' }, { size })} </p>
              : <p className="error-msg"> {formatMessage({ id: 'global.ui.upload.maxSize' }, { size })} </p>
          }
        </Modal>
      </Panel>
    );
  }
}
Avator.defaultProps = {

};
Avator.propTypes = {
  intl: intlShape.isRequired,
  userInfo: PropTypes.object.isRequired,
  setUserAvator: PropTypes.func.isRequired,
};


export default injectIntl(Avator);



// WEBPACK FOOTER //
// ./src/views/MySetting/component/avator.jsx